/* global Loader:true $:true Foundation:true Flickity:true */
// import 'babel-polyfill';
import {$tmpl, tmpl} from '@core/lib/strings';

import debug from "debug";


jQueryBridget( 'flickity', Flickity, $ );

window.Symbol = Symbol;
const ONE = 1;
const ZERO = 0;
const MODULE_NAME = 'module/product-detail';
const log = debug(MODULE_NAME);
const userAgentContains = (str) => navigator.userAgent.toLowerCase().indexOf(str.toLowerCase()) > -1;
const UA_HAS_SAFARI = userAgentContains("Safari");
const UA_HAS_CHROME = userAgentContains("Chrome");
const UA_HAS_OPERA = userAgentContains("op");
const UA_IS_SAFARI = UA_HAS_SAFARI && !UA_HAS_CHROME;
const UA_IS_CHROME = UA_HAS_CHROME && !UA_HAS_OPERA;



function getSliderOptions ($element) {
    const galleryOptionsAttr = 'data-flickity';
    if (UA_IS_SAFARI) {
        options.watchCSS = false;
    }
    return $element.attr(galleryOptionsAttr);
}

function GetGalleryElement () {
    return new Promise( (resolve, reject) => {
        const gallerySelector = '#modal-gallery .modal-gallery';
        const $element = $(gallerySelector);

        log('$element',$element);

        resolve($element);
    });
}

function InitGallery () {
    return new Promise( (resolve, reject) => {
        GetGalleryElement()
            .then(($element) => {
                let flickity = $element.data('flickity');
                if (!flickity) {
                    const options = getSliderOptions($element);
                    flickity = $element.flickity(options);
                }
                if (UA_IS_SAFARI) {
                    flickity.activate();
                }
                resolve(flickity);
            });
    });
}


function GetGallery () {
    return new Promise( (resolve, reject) => {
        GetGalleryElement()
            .then(InitGallery)
            .then((flickity) => {
                log('resolved gallery', flickity);
                resolve(flickity);
            });
    });
}

function DestroyGallery () {
    GetGalleryElement()
        .then(($element) => {
            const $gallery = $element.data('flickity');
            if ($gallery) {
                $gallery.destroy();
            }
        });
}

//  Flickity not initialised until carousel elements are visible
function BindGalleryEvents (gallery) {
    return new Promise( (resolve, reject) => {
        log('binding gallery events');

        gallery.on('select', () => {
            log('[initGalleryCarousel] flickity.select');
            UpdatePaginationStatus(gallery);
            SelectGalleryThumbnail(gallery.selectedIndex);
        });

        gallery.on('settle', () => {
            log('[initGalleryCarousel] flickity.settle');
            UpdatePaginationStatus(gallery);
            SelectGalleryThumbnail(gallery.selectedIndex);
        });

        resolve();
    });
}

function UpdatePaginationStatus (gallery) {
    return new Promise((resolve, reject) => {
        const total = $('.modal-gallery__thumbnail').length;
        const current = gallery.selectedIndex + ONE;

        log('UpdatePaginationStatus', gallery, total, current);

        $tmpl('.modal-gallery__pagination-status', {
            total: total,
            current: current
        });
    });
}

function SelectGallerySlide (slideIndex) {
    return GetGallery()
        .then( ($gallery) => {
            $gallery.select(slideIndex, false, true);
            return Promise.resolve($gallery);
        });
}

function SelectGalleryThumbnail (slideIndex) {
    const thumbnail = $('.modal-gallery__thumbnail').get(slideIndex);
    const $thumbnail = $(thumbnail);

    log(`selecting slide [${slideIndex}]`, thumbnail);

    $thumbnail
        .siblings()
        .removeClass('is-selected');

    $thumbnail
        .addClass('is-selected');

}


function ResizeGallery (gallery) {
    return new Promise((resolve, reject) => {
        log('repositioning gallery', gallery);
        gallery.reposition();
        log('resizing gallery', gallery);
        gallery.resize();
        resolve(gallery);
    });
}

function OnFlickityMainImageClick () {

    if (Foundation.MediaQuery.atLeast('medium')) {
        log('Setting up modal gallery');

        log('.product-detail-image-gallery__main-image:click');

        GetGallery()
            .then((gallery) => {
                $('#modal-gallery').foundation('open');
                return gallery;
            })
            .then((gallery) => {
                SelectGallerySlide(ZERO);
            });
    } else {
        DestroyGallery();
    }
}

function OnFlickityThumbnailClick () {
    if (Foundation.MediaQuery.atLeast('medium')) {
        const index = $(this).index();
        log('.modal-gallery__thumbnail:click');
        GetGallery()
            .then((gallery) => {
                $('#modal-gallery').foundation('open');
                return gallery;
            })
            .then((gallery) => {
                SelectGallerySlide(index);
            });
    } else {
        DestroyGallery();
    }
}

$(document).ready(() => {

    // Initialise flickity only when revealed

    $('#modal-gallery').one('open.zf.reveal', () => {
        const $modal = $('#modal-gallery');
        log('revealing modal gallery');
        GetGallery()
            .then(ResizeGallery)
            .then((gallery) => {
                const topPad = $(window).height() / 2 - $modal.height() / 2;
                $modal.css('top', topPad > 0 ? topPad : 0);
            });

    });


    /**
     * Removes foundation reveal modals.
     * see: https://jira.fusion.com.au/browse/DET001-105
     *  > Mobile no modal appears only slider of main image sized images.
     */
    if (Foundation.MediaQuery.current === 'small') {
        log('removing product image gallery modal.');

        const modalTargets = {};

        $('.product-detail-image-gallery [data-open]')
            .each(function GetModalTarget () {
                modalTargets[$(this).attr('data-open')] = true;
            });

        Object.keys(modalTargets).forEach((selector) => {
            $(`#${selector}`).foundation('destroy');
        });

    }

    if (Foundation.MediaQuery.atLeast('medium')) {
        log('Setting up modal gallery');

        $(`.product-detail-image-gallery__main-image`)
            .on('click', OnFlickityMainImageClick);

        $(`.modal-gallery__thumbnail, .product-detail-image-gallery__thumbnail-item`)
            .on('click', OnFlickityThumbnailClick);

        GetGallery()
            .then(BindGalleryEvents);
    }

});

Vue.component('pagination-test', {

    template: `<div class="something">A Test</div>`,

    ready () {
        log('ready');
    }

});





// WEBPACK FOOTER //
// ./client/src/scripts/module.product-detail.js